<template>
    <div class="login-container">
        <div class="login-box ">
            <div class="white-box" @click="openShoppingCart">
                 <a-badge :count="total">
                   <img src="@assets/img/index/shop-icon-green.png" alt="">
                 </a-badge>
               </div>
            <div class="user-avatar" v-if="!isLogin" @click="_changeLoginModal(true)">
                <div v-if="type" class="open-minded">开通VIP免费观看全站视频</div>
                <div class="login-or-register" :style="{color:type?'#35C7DE':'#333'}">登录/注册</div>
<!--                <a-avatar v-if="!type" class="avatar" :size="32" icon="user" />-->
            </div>
            <div class="user-avatar" v-else>
                <a-dropdown>
                    <div class="avatar-name-box">
                        <a-avatar class="avatar" :size="32" :src=userInfo.avatarUrl
                                  icon="user"/>

                      <div class="name-box">
                        <div> {{userInfo.nickname}}</div>
                        <div><img :src="memberDisplay().icon" alt=""> {{memberDisplay().name}}</div>
                      </div>
                    </div>
                    <a-menu slot="overlay" style="text-align: center">
                        <a-menu-item>
                            <router-link to="/other/personal/1">个人中心</router-link>
                        </a-menu-item>
                        <a-menu-item>
                            <router-link to="/other/personal/2">我的课程</router-link>
                        </a-menu-item>
                        <a-menu-item>
                            <router-link to="/other/personal/3">我的订单</router-link>
                        </a-menu-item>
                        <a-menu-item>
                            <span @click="logout">退出登录</span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import {logout} from "@api/personal-api";
    import {showError, showSuccessMsg} from "@utils/msg";
    import common from "../../../mixin/common";
    import goldIcon from "@assets/img/index/gold-diamond.png"
    import  diamondIcon from '@assets/img/index/transparent-diamond.png'
    import  silveryIcon from '@assets/img/index/silvery-diamond.png'
    import {memberDisplay} from "@utils/common";
    const {mapState} = createNamespacedHelpers('login');

    const {mapGetters} = createNamespacedHelpers('cart');


    export default {
        mixins: [common],
        props:{
            type:{
              type:Boolean,
              default:false
            }
        },
        data() {
            return {
                show: false,
                displayMember:{
                  silvery:{name:'青铜会员',icon:silveryIcon},
                  gold:{
                    name:'黄金会员',
                    icon:goldIcon
                  },
                  diamond:{name:'钻石会员',icon:diamondIcon}
                }
            }
        },
        methods: {
          memberDisplay,
            openShoppingCart(){
                if (this.isLoginClick()){
                    this.$router.push({
                        path:'/other/shopping-cart'
                    })
                }
            },
            logout() {
                //退出登录
                logout().then(res => {
                    if (res.code === 0) {
                        showSuccessMsg("退出成功...");
                        setTimeout(() => {
                            location.href = '/';
                        }, 500)
                    } else {
                        showError("退出失败", res.msg)
                    }
                });
            }
        },
        computed: {
            ...mapGetters([
                "total",
            ]),
            ...mapState({
                isLogin: 'isLogin',
                userInfo: "userInfo"
            })
        }
    }
</script>

<style scoped lang="less">

    .avatar-name-box{
      display: flex;
      align-items: center;
      .name-box{
        font-weight: 600;
        margin-left: 9px;
        img{
          width: 16px;
          margin-left: -20px;
          position: relative;
          z-index: 12;
        }
        &>:nth-child(2){
          color: #AB753F;
        }
      }

    }
    .login-box{
      width: 100%;
      display: flex;
      align-items: center;
    }
    .login-container {
        height: 100%;
        display: flex;
        align-items: center;

        font-size: 14px;

        a {
            color: #999999;
        }

      .white-box{
        width: 36px;
        height: 36px;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.23);
        display: flex;
        align-items: center;
        justify-content: center;
        margin:0 20px;
        img{
          cursor: pointer;
          width: 20px;
        }
      }

        /deep/ .ant-badge-count {
            background: #FF4400;
            min-width: 16px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            padding: 0;
            color: #fff;
            font-size: 10px;
        }

        .user-avatar {
            cursor: pointer;
            display: flex;
            align-items: center;
            position: relative;
            justify-content: center;

            .open-minded{
              position: absolute;
              font-size: 10px;
              top: -50px;
              width: 155px;
              height: 41px;
              text-align: center;
              line-height: 30px;
              font-weight: 500;
              background: url('~@assets/img/index/text-bg.png');
              background-size: 100%;
            }
            .login-or-register{
              width: 94px;
              height: 30px;
              background: #FFFFFF;
              box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.23);
              border-radius: 15px;
              font-weight: 600;
              font-size: 15px;
              text-align: center;
              line-height: 30px;
            }

        }

        .menu-list-container {
            text-align: center;

            a {
                text-align: center;
            }
        }
    }

    .nickname {
        display: inline-block;
        max-width: 80px;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle
    }
</style>
